import React from 'react';

import { Box, Icon } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

interface IWarningMessage {
  message: string;
  iconFillColor?: string;
}

const Container = Box.withConfig({
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  alignSelf: 'stretch',
  padding: 0,
});

const IconContainer = Box.withConfig({
  flexDirection: 'row',
  marginTop: 0,
  marginRight: '$1',
  marginBottom: 0,
  marginLeft: 0,
});

const Message = withTypography({
  m: '$0',
  fontSize: 'xs',
  textAlign: 'left',
  lineHeight: 14,
  style: { fontStyle: 'normal', fontWeight: 'normal' },
});

const WarningMessage: React.FC<React.PropsWithChildren<IWarningMessage>> = ({
  message,
  iconFillColor,
}) => (
  <Container>
    <IconContainer testID="error-icon">
      <Icon variant="error" color={iconFillColor} size="16px" aria-hidden />
    </IconContainer>
    <Message>{message}</Message>
  </Container>
);

export default WarningMessage;
